import { Constantes } from "@common/utils";
import React from "react";

export const useActiveItemPath = (menuItems) => {
    const activeItemPath = React.useMemo(() => {
        const validItems = menuItems
            .flatMap((item) => item.children)
            .filter((item) => !!item);

        let item = validItems.find(
            (item) => item.application === Constantes.APP_NAME
        );

        return item?.path;
    }, [menuItems]);

    return { activeItemPath };
};
